import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { IBranch } from '../../model/branch.model';
import { HttpStatusCode, ResponseModel } from '../../model/response.model';
import { ApiDataService } from '../../services/apidata.service';
import { AppService } from '../../services/app.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  branchList :IBranch[] =[];

  currentLang = 'en';
  public subscriptions$: Subscription[] = [];

  constructor(
    private apiservice: ApiDataService,
    private router: Router,
    public translate: TranslateService,
    public appservice: AppService
  ) { }

  ngOnInit(): void {
    this.getbranchList();
    // this.getsocialList();
    this.subscriptions$.push(
      //------------Subscribe languege change---------------------
      this.appservice.getcurrentLanguage().subscribe((locale) => {
        this.currentLang = locale;
        localStorage.setItem('locale', locale);
      })
    );

    this.currentLang = this.appservice.getSavecurrentLanguage();
  }


  getbranchList() {
    const url = `Branch/GetBranchList`;
    this.apiservice.getData(url).subscribe
      ((response: ResponseModel<any>) => {
        if (response.status === HttpStatusCode.OK) {
          this.branchList = response.data;
        }
      });
  }


  // getsocialList() {
  //   const url = `Banner/GetStaticdata`;
  //   this.apiservice.getData(url).subscribe
  //     ((response: ResponseModel<any>) => {
  //       if (response.status === HttpStatusCode.OK) {
  //         this.socialList = response.data;
  //       }
  //     });
  // }


  navtoaboutus(){
    this.router.navigateByUrl('/contactus');
  }
}
